import React, { useRef, useState } from "react";
import {
  withSitecoreContext,
  RichText,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { TextDropdownModuleModel } from "./models/TextDropdown.model";
import { TextDropdownModuleProps } from "./types/TextDropdown.types";

const TextDropdownModule = (props: TextDropdownModuleProps) => {
  const model = new TextDropdownModuleModel(props);
  const getDropdownList = props?.fields?.textValueList;
  const [isExtendedText, setCollapsedText] = useState(false);

  const contentRef = useRef(null);
  const showRef = useRef(null);

  function handleSelectChange(event) {
    const selectElement = event.target.value;
    const value = selectElement;
    const selectedOption = document && document.getElementById(`${value}`);

    document
      .querySelectorAll(".privacy-dropdown-content.show")
      .forEach(function (element) {
        element.classList.remove("show");
      });

    document
      .querySelectorAll(".privacy-dropdown-secondary")
      .forEach(function (element) {
        element?.classList?.remove("extended");
      });

    selectedOption && selectedOption.classList.add("show");
  }

  return (
    <>
      {props?.fields && (
      <div className="privacy-dropdown-wrapper">
        <select
          className="privacy-text-dropdown"
          ref={contentRef}
          onChange={handleSelectChange}
        >
          <option>{model?.placeholderLabel?.value ?? ''}</option>
          {getDropdownList.map((item, id) => (
            <option value={` ${id}`}>{item?.ID}</option>
          ))}
        </select>
        {getDropdownList.map((item, id) => (
          <div className="privacy-dropdown-content" id={` ${id}`} ref={showRef}>
            <div className="privacy-dropdown-title ">{item?.Title.value}</div>
            <div className="privacy-dropdown-primary">
              <RichText field={item?.PrimaryText} />
            </div>
            <div
              className={`privacy-dropdown-secondary  ${isExtendedText ? "extended" : ""
                }`}
            >
              <RichText field={item?.SecondaryText} />
            </div>
            <div
              className="privacy-dropdown-learnmore"
              onClick={() => setCollapsedText(!isExtendedText)}
            >
              {item?.LearnMoreLabel.value}
            </div>
          </div>
        ))}
      </div>
      )}
    </>

  );
};

export default withSitecoreContext()(TextDropdownModule);
